<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">pending_actions</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Transacciones pendientes Zelle</h1>
  </div>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros
      </h2>
    </div>
    <div class="p-5">
      <div class="flex flex-col sm:flex-row gap-4 items-end">
        <mat-form-field appearance="outline" class="flex-1 modern-field">
          <mat-label>Filtrar datos</mat-label>
          <mat-icon matPrefix style="color: #9ca3af;">search</mat-icon>
          <input matInput type="text" placeholder="Filtrar datos" [(ngModel)]="filterValue" (ngModelChange)="applyFilter()">
        </mat-form-field>
        <button type="button" (click)="reload()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease; height: 40px; margin-bottom: 4px;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">refresh</mat-icon>
          Refrescar
        </button>
      </div>
    </div>
  </div>

  <!-- Card Balances Cuentas -->
  <div *ngIf="limits.length > 0" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #fefce8, #fef9c3); padding: 16px 24px; border-bottom: 2px solid #fde68a; cursor: pointer;"
      (click)="showBalances = !showBalances">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #92400e; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #92400e;">account_balance</mat-icon>
        Balance de Cuentas
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #92400e; margin-left: auto; transition: transform 0.2s;"
          [style.transform]="showBalances ? 'rotate(180deg)' : 'rotate(0)'">expand_more</mat-icon>
      </h2>
    </div>
    <div class="p-5" *ngIf="showBalances">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <div *ngFor="let limit of limits" class="bg-gray-50 rounded-xl border border-gray-200 p-4">
          <p class="text-sm font-bold text-gray-800 mb-2">{{ limit.nombre }}</p>
          <p class="text-xs text-gray-500 mb-3">{{ limit.banco.nombre }}</p>
          <div class="grid grid-cols-2 gap-2 text-xs">
            <div>
              <span class="text-gray-400 font-semibold">Diario Zelle</span>
              <p class="text-gray-700 font-semibold">{{ limit.dailyLimitZelle?.total_monto_enviado ?? '0' }} / 3500</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold">Diario Bofa</span>
              <p class="text-gray-700 font-semibold">{{ limit.dailyLimitBofa?.total_monto_enviado ?? '0' }} / 8000</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold">Mensual Bofa</span>
              <p class="text-gray-700 font-semibold">{{ limit.enviadoMensualBofa ?? 0 }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold">Mensual Zelle</span>
              <p class="text-gray-700 font-semibold">{{ limit.enviadoMensualZelle ?? 0 }} / 20000</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Tabla -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
        Transacciones Pendientes
      </h2>
    </div>

    <!-- Paginator -->
    <div class="p-4">
      <mat-paginator #paginator
        (page)="onPageChange($event)"
        [length]="totalItems"
        [pageSize]="pageSize"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [pageIndex]="currentPage-1"
        aria-label="Select page">
      </mat-paginator>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="transactionsZelle" class="w-full">
        <!-- ID -->
        <ng-container matColumnDef="idTransferencia">
          <th mat-header-cell *matHeaderCellDef style="min-width: 60px;">ID</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-mono font-bold">{{ row.idTransferencia }}</td>
        </ng-container>

        <!-- Fecha Inicio -->
        <ng-container matColumnDef="fechaInicio">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Fecha inicio</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.fechaInicio | date:'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <!-- Fecha Termino -->
        <ng-container matColumnDef="fechaTermino">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Fecha término</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.fechaTermino ? (row.fechaTermino | date:'dd/MM/yyyy HH:mm') : 'No aplica' }}</td>
        </ng-container>

        <!-- Remitente -->
        <ng-container matColumnDef="remitente">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Remitente</th>
          <td mat-cell *matCellDef="let row" class="text-xs">
            {{ row.remitente }}
            <span *ngIf="$any(row).usuarioId" style="display: block; font-size: 0.7rem; font-weight: 700; color: #7c3aed; margin-top: 2px;">ID: {{ $any(row).usuarioId }}</span>
          </td>
        </ng-container>

        <!-- Beneficiario -->
        <ng-container matColumnDef="beneficiario">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Beneficiario</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.beneficiario || 'No aplica' }}</td>
        </ng-container>

        <!-- Tasa -->
        <ng-container matColumnDef="tn">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Tasa</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-semibold">{{ row.tn | currency:'$' }}</td>
        </ng-container>

        <!-- Monto CLP -->
        <ng-container matColumnDef="montoCLP">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">Monto CLP</th>
          <td mat-cell *matCellDef="let row" style="font-weight: 700; color: #1e5a3f; font-size: 0.8rem;">{{ row.montoCLP | currency:'$' }}</td>
        </ng-container>

        <!-- Monto USD -->
        <ng-container matColumnDef="montoUSDT">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">Monto USD</th>
          <td mat-cell *matCellDef="let row" style="font-weight: 700; color: #1e5a3f; font-size: 0.8rem;">{{ row.montoUSDT | currency:'$' }}</td>
        </ng-container>

        <!-- Banco -->
        <ng-container matColumnDef="banco">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">Banco</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ $any(row).banco }}</td>
        </ng-container>

        <!-- Direccion -->
        <ng-container matColumnDef="identificador">
          <th mat-header-cell *matHeaderCellDef style="min-width: 160px;">Dirección</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ $any(row).codigoBanco === 'BOFA' ? $any(row).numeroCuenta : row.direccionZelle }}</td>
        </ng-container>

        <!-- Estado -->
        <ng-container matColumnDef="estadoActual">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Estado</th>
          <td mat-cell *matCellDef="let row">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.background]="row.estadoActual === 'POR_PROCESAR' ? '#fef3c7' : row.estadoActual === 'ENVIADA' ? '#dcfce7' : '#fef2f2'"
              [style.color]="row.estadoActual === 'POR_PROCESAR' ? '#92400e' : row.estadoActual === 'ENVIADA' ? '#166534' : '#dc2626'">
              {{ row.estadoActual.replaceAll('_', ' ') }}
            </span>
          </td>
        </ng-container>

        <!-- Acciones -->
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px; text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let row" style="text-align: center;">
            <div class="flex items-center justify-center gap-1">
              <button type="button" title="Copiar" (click)="copy(row)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: #f9fafb; cursor: pointer;"
                onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='#f9fafb'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">content_copy</mat-icon>
              </button>
              <button type="button" title="Pagar" (click)="openSendTransactionModal(row)" [disabled]="row.estadoActual !== 'POR_PROCESAR'"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;"
                [style.opacity]="row.estadoActual !== 'POR_PROCESAR' ? '0.4' : '1'"
                [style.cursor]="row.estadoActual !== 'POR_PROCESAR' ? 'not-allowed' : 'pointer'"
                onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">done</mat-icon>
              </button>
              <button type="button" title="Rechazar" (click)="openRejectTransactionModal(row)" [disabled]="row.estadoActual !== 'POR_PROCESAR'"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;"
                [style.opacity]="row.estadoActual !== 'POR_PROCESAR' ? '0.4' : '1'"
                [style.cursor]="row.estadoActual !== 'POR_PROCESAR' ? 'not-allowed' : 'pointer'"
                onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">close</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden p-4 space-y-3">
      <div *ngFor="let row of transactionsZelle; let i = index"
        class="bg-white rounded-xl border transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">
        <!-- Card Header -->
        <div class="flex items-center justify-between p-3 cursor-pointer" (click)="toggleCard(i)">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="inline-block text-xs font-mono font-bold px-2 py-0.5 rounded-full bg-gray-100 text-gray-700">#{{ row.idTransferencia }}</span>
            <span class="text-xs font-semibold text-gray-700 truncate">{{ row.beneficiario || row.remitente }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.background]="row.estadoActual === 'POR_PROCESAR' ? '#fef3c7' : row.estadoActual === 'ENVIADA' ? '#dcfce7' : '#fef2f2'"
              [style.color]="row.estadoActual === 'POR_PROCESAR' ? '#92400e' : row.estadoActual === 'ENVIADA' ? '#166534' : '#dc2626'">
              {{ row.estadoActual.replaceAll('_', ' ') }}
            </span>
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #6b7280; transition: transform 0.2s;"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">expand_more</mat-icon>
          </div>
        </div>
        <!-- Card Body -->
        <div *ngIf="expandedCardId === i" class="border-t border-gray-100 p-3">
          <div class="grid grid-cols-2 gap-3 text-xs mb-3">
            <div>
              <span class="text-gray-400 font-semibold uppercase">Remitente</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ row.remitente }}</p>
              <span *ngIf="$any(row).usuarioId" style="font-size: 0.7rem; font-weight: 700; color: #7c3aed;">ID: {{ $any(row).usuarioId }}</span>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase">Beneficiario</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ row.beneficiario || 'No aplica' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase">Monto CLP</span>
              <p style="font-weight: 700; color: #1e5a3f; margin-top: 2px;">{{ row.montoCLP | currency:'$' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase">Monto USD</span>
              <p style="font-weight: 700; color: #1e5a3f; margin-top: 2px;">{{ row.montoUSDT | currency:'$' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase">Banco</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ $any(row).banco }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase">Dirección</span>
              <p class="text-gray-800 font-medium mt-0.5 truncate">{{ $any(row).codigoBanco === 'BOFA' ? $any(row).numeroCuenta : row.direccionZelle }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase">Fecha inicio</span>
              <p class="text-gray-800 font-medium mt-0.5">{{ row.fechaInicio | date:'dd/MM/yyyy HH:mm' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase">Tasa</span>
              <p class="text-gray-800 font-semibold mt-0.5">{{ row.tn | currency:'$' }}</p>
            </div>
          </div>
          <div class="flex gap-2 pt-2 border-t border-gray-100">
            <button type="button" (click)="copy(row); $event.stopPropagation()"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #d1d5db; border-radius: 8px; background: #f9fafb; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #374151;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #374151;">content_copy</mat-icon>
              Copiar
            </button>
            <button type="button" *ngIf="row.estadoActual === 'POR_PROCESAR'" (click)="openSendTransactionModal(row); $event.stopPropagation()"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #bbf7d0; border-radius: 8px; background: #f0fdf4; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #166534;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #166534;">done</mat-icon>
              Pagar
            </button>
            <button type="button" *ngIf="row.estadoActual === 'POR_PROCESAR'" (click)="openRejectTransactionModal(row); $event.stopPropagation()"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">close</mat-icon>
              Rechazar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
